export default __webpack_public_path__ + "static/media/hawaii.a71b939e.JPG";